import { render, staticRenderFns } from "./scoring-cycle-list.vue?vue&type=template&id=125a9fee&scoped=true"
import script from "./scoring-cycle-list.vue?vue&type=script&lang=js"
export * from "./scoring-cycle-list.vue?vue&type=script&lang=js"
import style0 from "./scoring-cycle-list.vue?vue&type=style&index=0&id=125a9fee&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125a9fee",
  null
  
)

export default component.exports